<template>
  <CRow>
    <CCol>
      <p style="margin-bottom: 8px;">{{ title }}
        <span v-if="isRequired" class="asterisk">必須</span>
      </p>
      <select
        class="form-control form-select"
        :id="keyName"
        :value="inputValue"
        @change="handlePrefectureInput"
      >
        <option
          v-for="option in optionArray"
          :key="option.id"
          :value="option.prefName"
          style="display: flex; align-items: center; margin-right: 16px;"
          >{{ option.prefName }}</option
        >
      </select>
    </CCol>
  </CRow>
</template>

<script>
import { defineObject } from '@/lib/define/use-define'
export default {
  data() {
    return {}
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    optionArray: {
      type: Array,
      required: true,
    },
    keyName: {
      type: String,
      required: true,
    },
    inputValue: {
      type: String,
      required: true,
    },
    isRequired: {
      type: Boolean,
      required: false,
    }
  },
  methods: {
    handlePrefectureInput(e) {
      this.$emit('prefecture-input', e.target.value)
    },
  },
}
</script>

<style lang="scss" scoped>
.asterisk {
  position: relative;
  padding-left: 20px;
  color: #ea5550;
  font-size: 12px;
  font-weight: bold;
  &::before {
    content: '※';
    position: absolute;
    top: calc(50% - 2px);
    left: 9px;
    transform: translateY(-50%);
  }
}
</style>
